import { useState } from 'react'
import { cn } from '@/lib/utils'
import type { PaymentMethodConfig } from '@/types/payment'

interface PaymentMethodCardProps {
	method: PaymentMethodConfig
	isSelected: boolean
	onSelect: () => void
}

export function PaymentMethodCard({ method, isSelected, onSelect }: PaymentMethodCardProps) {
	const Icon = method.icon
	const [isFocused, setIsFocused] = useState(false)
	const isActive = isFocused

	return (
		<div className={cn('group h-14 overflow-hidden rounded-xl border p-0.5 transition-colors', isActive ? 'border-primary' : 'border-border')}>
			<button
				type='button'
				onClick={onSelect}
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				className={cn(
					'flex h-full w-full items-center justify-between gap-2 overflow-hidden rounded-[11px] pl-1 pr-3.5 text-left transition-colors focus:outline-none',
					isActive ? 'bg-secondary bg-[linear-gradient(90deg,hsl(var(--primary)/0.12)_1.15%,hsl(var(--primary)/0)_82.95%)]' : 'bg-secondary',
				)}
			>
				<span className='flex min-w-0 items-center gap-2'>
					<span
						aria-hidden
						className={cn(
							'h-6 w-0.5 shrink-0 rounded-full transition-[background-color,box-shadow]',
							isActive
								? 'bg-primary shadow-[0_0_12px_6px_hsl(var(--primary)/0.6)]'
								: 'bg-border group-hover:bg-primary group-hover:shadow-[0_0_8px_2px_hsl(var(--primary)/0.35)]',
						)}
					/>
					{Icon ? (
						<Icon className={cn('h-6 w-6 shrink-0 transition-colors', isActive ? 'text-primary' : 'text-icon-muted group-hover:text-primary')} />
					) : method.iconUrl ? (
						<img src={method.iconUrl} alt='' className='h-6 w-6 shrink-0 object-contain' />
					) : null}
					<span
						className={cn(
							'min-w-0 truncate text-sm tracking-[-0.21px] transition-colors',
							isSelected || isActive ? 'font-medium text-foreground' : 'font-normal text-muted-foreground',
						)}
					>
						{method.label}
					</span>
				</span>

				<span
					className={cn(
						'box-border h-5 w-5 shrink-0 rounded-full bg-transparent',
						isActive ? 'border-[5px] border-primary bg-secondary' : 'border-2 border-muted-foreground/50 bg-secondary',
					)}
					aria-hidden
				/>
			</button>
		</div>
	)
}
